var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.142 19.362h-4.38c-.636 0-1.114.478-1.114 1.115s.478 1.115 1.115 1.115h4.38c.636 0 1.114-.478 1.114-1.115s-.478-1.115-1.115-1.115zM6.48.968C3.452 1.526 1.063 3.994.506 6.94c-.557 2.947.557 5.574 2.548 7.247.398.318.558.796.558 1.274v.955c0 .956.796 1.752 1.751 1.752h5.256c.955 0 1.752-.796 1.752-1.752v-.955c0-.478.159-.956.557-1.274 1.672-1.434 2.707-3.504 2.707-5.813 0-4.619-4.3-8.361-9.157-7.406zM7.513 13.55l-.08-3.663H5.764l.955-4.3h2.787L8.55 8.613h1.672L7.514 13.55z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faqIcon.05e719c4c5fb675eae700ddeb77d4c1d.svg";
export { ForwardRef as ReactComponent };